import React, { useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";
import "./whatsAppButton.scss";

// Contacto configurado: username de WhatsApp @iovec. El enlace público
// `wa.me` está pensado para números de teléfono (código de país + dígitos);
// con un username en vez de un número no hay garantía de que WhatsApp lo
// resuelva igual en todos los dispositivos/versiones de la app. Si en algún
// momento se confirma que no abre el chat correctamente, reemplázalo por el
// número de teléfono real de esa cuenta en formato internacional.
const WHATSAPP_USERNAME = "iovec"; // <- usuario de WhatsApp, sin "@"
const DEFAULT_MESSAGE = "Hola, tengo una consulta sobre ASSA ABLOY Colombia.";

const buildWhatsAppUrl = (message) =>
  `https://wa.me/${WHATSAPP_USERNAME}?text=${encodeURIComponent(message)}`;

/**
 * Botón flotante de contacto por WhatsApp, visible en toda la plataforma.
 * Al hacer clic abre wa.me con el contacto configurado en una pestaña nueva.
 * Responsivo: en móvil queda más compacto y respeta el área segura (notch).
 */
const WhatsAppButton = () => {
  const [expanded, setExpanded] = useState(false);

  const openWhatsApp = () => {
    window.open(buildWhatsAppUrl(DEFAULT_MESSAGE), "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className={`whatsapp-fab-wrapper${expanded ? " expanded" : ""}`}
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      {expanded && (
        <div className="whatsapp-tooltip" onClick={openWhatsApp}>
          <span>¿Necesitas ayuda? Escríbenos</span>
          <CloseIcon
            fontSize="small"
            className="whatsapp-tooltip-close"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(false);
            }}
          />
        </div>
      )}
      <button
        type="button"
        className="whatsapp-fab"
        onClick={openWhatsApp}
        aria-label="Contactar por WhatsApp"
        title="Contactar por WhatsApp"
      >
        <WhatsAppIcon />
      </button>
    </div>
  );
};

export default WhatsAppButton;
